module.exports = __webpack_public_path__ + "img/logo-app.d715e9c6.svg";